<template>
  <div class="row card__row items-center justify-center q-gutter-lg">
    <div
      v-for="type in products"
      :key="type.id"
      class="text-center col-lg-6 col-xs-10 card__type cursor-pointer"
      @click="atSetVehicleType({ type })"
    >
      <q-img
        class="card__type--img"
        :class="{ bike: type.category === 'A' }"
        :src="`svg/${type.category}.svg`"
      />
      <div class="text-weight-bold q-pt-md">
        {{ $t(`types.${type.category}.title`) }}
      </div>

      <div class="card__type--price text-accent q-my-xs">
        {{ formatPriceISK(type.price.amount) }}
      </div>

      <div>{{ $t(`types.${type.category}.passengers`) }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import price from 'src/mixins/price';

export default {
  name: 'CarTypes',
  mixins: [price],

  data() {
    return {
      types: [],
    };
  },

  computed: {
    ...mapState('product', ['products']),
    ...mapState('vehicle', ['type']),
  },

  mounted() {
    // Unset vehicle type, otherwise the same type cannot be selected again
    if (this.type) {
      this.atSetVehicleType({ type: null });
    }
  },

  methods: {
    ...mapMutations('vehicle', ['atSetVehicleType']),
  },
};
</script>
